import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPlus, FiMinus } = FiIcons;

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Can I use my own car?',
      answer: 'For safety reasons, we recommend using our instructor\'s car for your first lesson. Once you\'re comfortable, we can discuss using your own vehicle.'
    },
    {
      question: 'How many lessons will I need?',
      answer: 'The number of lessons varies for each student. We provide personalised progress tracking to help determine your individual needs and readiness for the test.'
    },
    {
      question: 'Are evening and weekend lessons available?',
      answer: 'Yes, we offer evening and weekend lessons to accommodate your schedule. However, these popular time slots book up quickly, so we recommend booking early.'
    },
    {
      question: 'Do you offer intensive courses?',
      answer: 'Yes, we offer intensive courses tailored to your schedule and learning needs. These courses are designed to help you pass your test faster with concentrated lessons.'
    },
    {
      question: 'Can I bring my child to the lesson?',
      answer: 'Yes! Subject to terms and conditions stipulated by your instructor.'
    }
  ];

  return (
    <section className="py-20 bg-white dark:bg-gray-900 transition-colors duration-300">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4 transition-colors">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 transition-colors">
            Get answers to common questions about our driving lessons.
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-gray-50 dark:bg-gray-800 rounded-lg overflow-hidden border border-gray-100 dark:border-gray-700 transition-colors duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
              >
                <span className="font-semibold text-gray-900 dark:text-white transition-colors">{faq.question}</span>
                <SafeIcon
                  icon={openIndex === index ? FiMinus : FiPlus}
                  className="w-5 h-5 text-blue-600 dark:text-blue-400 transition-colors"
                />
              </button>
              {openIndex === index && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: 'auto' }}
                  exit={{ opacity: 0, height: 0 }}
                  className="px-6 pb-4"
                >
                  <p className="text-gray-600 dark:text-gray-300 leading-relaxed transition-colors">{faq.answer}</p>
                </motion.div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;